module.exports = require("instafeed.js");


//////////////////
// WEBPACK FOOTER
// external "instafeed.js"
// module id = 248
// module chunks = 0